import React from "react";
import "./contactus.css";
import Footer from "../components/footer";
import HomeHeader from "../home/new/components/homeHeader";

const ContactPage = () => {
  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.target;
    const formData = {
      name: form.name.value,
      email: form.email.value,
      help: form.help.value,
    };

    try {
      // Fetch request to your API endpoint
      const response = await fetch("/api/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Email sent successfully!");
      } else {
        alert("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div>
      <HomeHeader
        isTitle={false}
        title={""}
        headerColor="header-white"
        navItems={true}
      />
      <div className="contact-page">
        <div className="contact-container">
          <div className="contact-info">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-description">
              Request a demo or more information about our services. Whether
              you're a client or a lawyer, we're here to provide the details you
              need.
            </p>

            <div className="info-cards">
              <div className="info-card">
                <h3>Why Choose Us?</h3>
                <p>
                  Discover how our AI-driven platform simplifies legal services
                  and connects you with top lawyers efficiently.
                </p>
              </div>
              <div className="info-card">
                <h3>Tailored Legal Solutions</h3>
                <p>
                  Our platform adapts to your unique legal needs, providing
                  customized advice and seamless lawyer connections.
                </p>
              </div>
              <div className="info-card">
                <h3>How Our AI Works</h3>
                <p>
                  Learn how our advanced AI technology offers quick, accurate
                  legal insights to guide your decisions.
                </p>
              </div>
              <div className="info-card">
                <h3>Flexible Plans</h3>
                <p>
                  Learn how our advanced AI technology offers quick, accurate
                  legal insights to guide your decisions.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side: Contact Form */}
          <div className="contact-form-container">
            <div className="contact-form">
              <h2 className="form-title">Get in Touch</h2>
              <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-field full-width">
                    <label>Name</label>
                    <input type="text" name="name" required />
                  </div>
                  <div className="form-field full-width">
                    <label>Email Address</label>
                    <input type="email" name="email" required />
                  </div>
                  <div className="form-field full-width">
                    <label>How can we help?</label>
                    <textarea name="help" rows="4" required></textarea>
                  </div>
                  <div className="form-field full-width">
                    <button type="submit" className="submit-button-contact">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <p className="privacy-note">
                By contacting us, you agree to our{" "}
                <a href="#">Terms of Service</a> and{" "}
                <a href="#">Privacy Policy</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
